// extracted by mini-css-extract-plugin
export default {"body":"Mentors_body__6MZNa","title":"Mentors_title__MIWnU","filters":"Mentors_filters__Fl9WD","mentors":"Mentors_mentors__QDSPe","empty":"Mentors_empty__YSsh4"};